module.exports = __webpack_public_path__ + "img/smouha-alamein.c0db0600.svg";